import React from 'react';
import { Icon, Spin, StatusPill, InvPill, MarginChip, StatusDot,
         Drawer, Modal, Tabs, FG, RG } from '../components/ui.jsx';
import { api, fmt, fmtD, dayN } from '../api.js';
import { ChartCanvas } from '../components/chart.jsx';
import { ROLES, RL, TIPOLOGIE, REGIE, STATUSES, SL, INVOICE, MAT_CAT, MONTHS,
         STATUS_COLORS, INV_COLORS } from '../constants.js';


export const Dashboard =({onNav})=>{
  const [data,setData]=React.useState(null);
  const [kpi,setKpi]=React.useState(null);
  React.useEffect(()=>{api('/dashboard').then(setData).catch(()=>{});api('/dashboard/kpi').then(setKpi).catch(()=>{});},[]);
  if(!data)return<div className="empty"><Spin/> Caricamento...</div>;
  const {stats,upcoming,incomplete_crew,by_employment_type,top_costs}=data;
  const totCosti=(+(stats.budget_crew_totale||0))+(+(stats.budget_spese_totale||0));
  const margine=(+(stats.revenue_totale||0))-totCosti;

  return(
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Dashboard</div>
          <div className="page-title-sub">Panoramica cantieri EjaTV</div>
        </div>
        <button className="btn btn-primary" onClick={()=>onNav('projects','new')}>
          <Icon name="plus" size={14} color="#fff"/>Nuovo cantiere
        </button>
      </div>

      {/* KPI */}
      <div className="kpi-row">
        {[
          {icon:'clapperboard',val:stats.upcoming_count,label:'Prossimi cantieri',color:'var(--blue)',cls:'kpi-card--blue'},
          {icon:'check-circle',val:stats.confirmed_count,label:'Confermati',color:'#065F46',cls:'kpi-card--green'},
          {icon:'users',val:stats.active_technicians,label:'Tecnici attivi',color:'var(--n800)',cls:''},
          {icon:'trending-up',val:fmt(stats.revenue_totale),label:'Revenue attiva',color:'var(--blue)',cls:'kpi-card--gold',sm:true},
        ].map(k=>(
          <div key={k.label} className={`kpi-card ${k.cls||''}`}>
            <Icon name={k.icon} size={20} color={k.color} style={{marginBottom:10}}/>
            <div className="kpi-val" style={{color:k.color,fontSize:k.sm?'1.2rem':'1.6rem'}}>{k.val}</div>
            <div className="kpi-lbl">{k.label}</div>
          </div>
        ))}
      </div>

      <div className="grid grid-2" style={{marginBottom:16}}>
        {/* Marginalita */}
        <div className="card">
          <div className="card-title"><Icon name="pie-chart" size={12} color="var(--n400)"/>Marginalita complessiva</div>
          {[
            ['Revenue',stats.revenue_totale,'#065F46'],
            ['Costi crew',stats.budget_crew_totale,'var(--n600)'],
            ['Spese operative',stats.budget_spese_totale,'var(--n600)'],
          ].map(([l,v,c])=>(
            <div key={l} className="budget-row">
              <span className="budget-label">{l}</span>
              <span className="budget-amount" style={{color:c}}>{fmt(v)}</span>
            </div>
          ))}
          <div className="budget-total">
            <div className="flex-between">
              <span style={{fontSize:13,fontWeight:600,color:'var(--blue)'}}>Margine netto</span>
              <span style={{fontSize:18,fontWeight:700,color:margine>=0?'#065F46':'#991B1B'}}>{fmt(margine)}</span>
            </div>
          </div>
        </div>

        {/* Organico */}
        <div className="card">
          <div className="card-title"><Icon name="user-check" size={12} color="var(--n400)"/>Organico</div>
          {by_employment_type.map(t=>(
            <div key={t.employment_type} className="budget-row">
              <span className="budget-label">
                <span className={`emp-badge emp-${t.employment_type||'freelance'}`}>{t.employment_type}</span>
                <span style={{marginLeft:8}}>{t.n} persone</span>
              </span>
              <span style={{fontSize:12,color:'var(--n400)'}}>{fmt(t.total_rate)}/g media</span>
            </div>
          ))}
          {!by_employment_type.length&&<div style={{fontSize:12,color:'var(--n400)'}}>Nessun tecnico</div>}
        </div>
      </div>

      {/* Alert crew incompleta */}
      {incomplete_crew.length>0&&(
        <div className="card" style={{borderLeft:'3px solid #F59E0B',marginBottom:16,padding:'16px 20px'}}>
          <div className="card-title" style={{color:'var(--warn)',marginBottom:10}}>
            <Icon name="alert-triangle" size={12} color="#B45309"/>
            Cantieri senza capo tecnico ({incomplete_crew.length})
          </div>
          {incomplete_crew.slice(0,5).map(e=>(
            <div key={e.id} className="crew-slot" style={{cursor:'pointer'}}
              onClick={()=>onNav('projects',e.id)}>
              <div>
                <span style={{fontWeight:600,fontSize:13,color:'var(--blue)'}}>{e.code}</span>
                <span style={{marginLeft:8,fontWeight:500}}>{e.title}</span>
                <span style={{fontSize:11,color:'var(--n400)',marginLeft:8}}>{fmtD(e.date_start)}</span>
              </div>
              <Icon name="chevron-right" size={14} color="var(--n400)"/>
            </div>
          ))}
        </div>
      )}

      <div className="grid grid-2">
        {/* Prossimi */}
        <div className="card">
          <div className="card-title"><Icon name="calendar" size={12} color="var(--n400)"/>Prossimi cantieri</div>
          {upcoming.map(e=>(
            <div key={e.id} className="crew-slot" style={{cursor:'pointer'}} onClick={()=>onNav('projects',e.id)}>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontWeight:600,fontSize:13,display:'flex',alignItems:'center',gap:6}}>
                  <span style={{color:'var(--blue)',fontSize:11}}>{e.code}</span>
                  <span>{e.title}</span>
                </div>
                <div style={{fontSize:11,color:'var(--n400)',marginTop:2}}>
                  {fmtD(e.date_start)}   {e.client_name||'-'}   {e.manager_name||'-'}
                </div>
              </div>
              <div style={{textAlign:'right',flexShrink:0}}>
                <StatusPill val={e.status}/>
                {e.revenue>0&&<div style={{fontSize:11,color:'#065F46',fontWeight:600,marginTop:3}}>{fmt(e.revenue)}</div>}
              </div>
            </div>
          ))}
          {!upcoming.length&&<div className="empty" style={{padding:20}}>Nessun cantiere</div>}
        </div>

        {/* Tecnici con conferme pendenti */}
        {data.pending_confirmations&&data.pending_confirmations.length>0&&(
          <div className="card" style={{gridColumn:'span 2',borderLeft:'3px solid #F59E0B',padding:'14px 18px',marginBottom:0}}>
            <div className="card-title" style={{color:'var(--warn)',marginBottom:8}}>
              <Icon name="clock" size={12} color="#B45309"/>
              Conferme in sospeso ({data.pending_confirmations.length} tecnici)
            </div>
            <div style={{display:'flex',flexWrap:'wrap',gap:6}}>
              {data.pending_confirmations.map(t=>(
                <span key={t.crew_id} style={{background:'#FEF3C7',border:'1px solid #FDE68A',
                  borderRadius:8,padding:'4px 10px',fontSize:12,cursor:'pointer',
                  color:'#92400E',fontWeight:500}}
                  onClick={()=>onNav('projects',t.project_id)}>
                  {t.technician_name} - {t.project_code}
                </span>
              ))}
            </div>
          </div>
        )}
        {/* Top costi */}
        <div className="card">
          <div className="card-title"><Icon name="bar-chart-2" size={12} color="var(--n400)"/>Top costi per cantiere</div>
          {top_costs.map((e,i)=>(
            <div key={e.id} className="crew-slot" style={{cursor:'pointer'}} onClick={()=>onNav('account',null)}>
              <div style={{display:'flex',alignItems:'center',gap:10,flex:1}}>
                <span style={{width:22,height:22,borderRadius:'50%',background:'var(--n100)',
                  border:'1px solid var(--n200)',display:'flex',alignItems:'center',
                  justifyContent:'center',fontSize:11,color:'var(--n400)',flexShrink:0}}>{i+1}</span>
                <div>
                  <div style={{fontWeight:600,fontSize:13}}>{e.title}</div>
                  <div style={{fontSize:11,color:'var(--n400)'}}>{e.code}   {fmtD(e.date_start)}</div>
                </div>
              </div>
              <span style={{fontWeight:700,color:'var(--blue)',fontSize:14}}>{fmt(e.costo_totale)}</span>
            </div>
          ))}
          {!top_costs.length&&<div style={{fontSize:12,color:'var(--n400)',padding:8}}>
            Inserisci tariffe e budget per vedere i costi
          </div>}
        </div>
      </div>

      {/* GRAFICI */}
      {kpi && (
        <>
          <div className="grid grid-2" style={{marginTop:16}}>
            {/* Trend mensile — Bar chart */}
            <div className="card">
              <div className="card-title"><Icon name="bar-chart-2" size={13} color="var(--blue)"/> Trend mensile {kpi.year}</div>
              <ChartCanvas type="bar" height={260} data={{
                labels: (kpi.monthly_trend||[]).map(m => ['','Gen','Feb','Mar','Apr','Mag','Giu','Lug','Ago','Set','Ott','Nov','Dic'][m.month]),
                datasets: [
                  {label:'Revenue', data:(kpi.monthly_trend||[]).map(m=>+(m.revenue||0)),
                   backgroundColor:'rgba(49,54,122,0.85)', borderRadius:6, barPercentage:0.6},
                  {label:'Spese', data:(kpi.monthly_trend||[]).map(m=>+(m.spese||0)),
                   backgroundColor:'rgba(239,68,68,0.5)', borderRadius:6, barPercentage:0.6},
                ]
              }} options={{
                scales:{y:{beginAtZero:true,ticks:{font:{size:10},callback:v=>'€'+v.toLocaleString('it-IT')},grid:{color:'rgba(0,0,0,.04)'}},
                        x:{ticks:{font:{size:11}},grid:{display:false}}},
                plugins:{legend:{display:true}}
              }}/>
            </div>

            {/* Revenue per cliente — Doughnut */}
            <div className="card">
              <div className="card-title"><Icon name="pie-chart" size={13} color="#E6960A"/> Revenue per cliente</div>
              {(kpi.by_client||[]).some(c => +(c.revenue||0) > 0) ? (
                <ChartCanvas type="doughnut" height={260} data={{
                  labels: (kpi.by_client||[]).map(c => c.client_name||'N/A'),
                  datasets: [{
                    data: (kpi.by_client||[]).map(c => +(c.revenue||0)),
                    backgroundColor: ['#31367A','#E6960A','#0E9F6E','#4A90D9','#9F7AEA','#F59E0B','#EF4444','#64748B'],
                    borderWidth: 2, borderColor: '#fff',
                  }]
                }} options={{
                  cutout:'55%',
                  plugins:{legend:{display:true,position:'right',labels:{font:{size:10},padding:8}}}
                }}/>
              ) : (
                <div style={{height:260,display:'flex',alignItems:'center',justifyContent:'center',color:'var(--n300)',fontSize:13}}>
                  Inserisci revenue nei cantieri per vedere il grafico
                </div>
              )}
            </div>
          </div>

          <div className="grid grid-2" style={{marginTop:16}}>
            {/* Cantieri per cliente — Horizontal bar */}
            <div className="card">
              <div className="card-title"><Icon name="building" size={13} color="var(--blue)"/> Cantieri per cliente</div>
              <ChartCanvas type="bar" height={240} data={{
                labels: (kpi.by_client||[]).map(c => c.client_name||'N/A'),
                datasets: [{
                  label:'Cantieri', data:(kpi.by_client||[]).map(c => +(c.cantieri||0)),
                  backgroundColor:'rgba(49,54,122,0.7)', borderRadius:6, barPercentage:0.6,
                }]
              }} options={{
                indexAxis:'y',
                scales:{x:{beginAtZero:true,ticks:{font:{size:10},stepSize:1},grid:{color:'rgba(0,0,0,.04)'}},
                        y:{ticks:{font:{size:11}},grid:{display:false}}},
                plugins:{legend:{display:false}}
              }}/>
            </div>

            {/* Top tecnici — Horizontal bar */}
            <div className="card">
              <div className="card-title"><Icon name="users" size={13} color="#0E9F6E"/> Top tecnici per giornate</div>
              <ChartCanvas type="bar" height={240} data={{
                labels: (kpi.top_technicians||[]).map(t => t.name),
                datasets: [{
                  label:'Giornate', data:(kpi.top_technicians||[]).map(t => +(t.giorni||0)),
                  backgroundColor:(kpi.top_technicians||[]).map(t => t.employment_type==='dipendente'?'rgba(49,54,122,0.8)':'rgba(14,159,110,0.7)'),
                  borderRadius:6, barPercentage:0.6,
                }]
              }} options={{
                indexAxis:'y',
                scales:{x:{beginAtZero:true,ticks:{font:{size:10},stepSize:1},grid:{color:'rgba(0,0,0,.04)'}},
                        y:{ticks:{font:{size:11}},grid:{display:false}}},
                plugins:{legend:{display:false}}
              }}/>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

// ============================================================
// PROJECT FORM (usato sia in modal che in drawer)
// ============================================================
